// extracted by mini-css-extract-plugin
module.exports = {"container":"Dependencies_container__3b7k1","column":"Dependencies_column__pknQ5","items":"Dependencies_items__1QKbJ"};